import React from 'react';
import Img from '../../Img';

import styles from './checkBox.scss';

const CheckBox = (props) => {
    const { 'data-testid': dataTestId } = props;
    return (
        <div
            className={`${styles.checkBoxContainer} ${props.colClass ? props.colClass : ''} ${props.item.isSelected ? styles.selected : ''}`}
            onClick={() => {
                props.onChanged(props.item);
            }}
            data-testid={dataTestId}
        >
            <div className={`${styles.checkIcon}`}>
                {props.item.isSelected && (
                    <Img src="/img/check-mark.svg" />
                )}
            </div>
            <div className={`${styles.label} get-rated-label`} data-testid={dataTestId && `${dataTestId}.label`}>
                {props.item.name}
            </div>
        </div>
    );
};

export default CheckBox;
